import {GET_DEVICES, SET_COMMAND} from "../../redux/types";

export const GET_DEVICES_START = "GET_DEVICES_START";

export const getDevices = email => dispatch => {
    dispatch({type: GET_DEVICES_START});

    dispatch({
        type: GET_DEVICES,
        payload: email
    });
};


export const SET_COMMAND_START = "SET_COMMAND_START";

export const setCommand = action => dispatch => {
    dispatch({type: SET_COMMAND_START});

    dispatch({
        type: SET_COMMAND,
        payload: action
    });
};



// WEBPACK FOOTER //
// ./src/containers/devices/DevicesActions.js